import DeviceRequirementsError from ".";

export default function DeviceRequirementsErrorExamples() {
  return (
    <DeviceRequirementsError onComeBackLater={() => {}} onTryAgain={() => {}} />
  );
}
